import _styled from "styled-components";
import { AnimatePresence } from "framer-motion";
import { useDeepDiveGallery } from "~/features/blocks/inventory/deep-dive-gallery/context";
import { DeepDiveGalleryControlProgress } from "~/features/blocks/inventory/deep-dive-gallery/deep-dive-gallery-controls/deep-dive-gallery-control-progress";
export type DeepDiveGalleryControlViewProps = {
  image?: React.ReactNode;
  index: number;
};
export function DeepDiveGalleryControlView(props: DeepDiveGalleryControlViewProps) {
  const {
    image,
    index
  } = props;
  const {
    activeStepIndex,
    isVideoPlaying,
    goTo
  } = useDeepDiveGallery();
  const isActive = activeStepIndex === index;
  const isDisabled = isVideoPlaying;
  return <_StyledButton id={`control-${index}`} onClick={() => goTo(index)} disabled={isDisabled} style={{
    pointerEvents: isDisabled ? "none" : "auto"
  }} aria-label={`Explore ${index + 1}`} $_css={[{
    "position": "relative",
    "height": "3.2rem",
    "width": "4.8rem",
    "flexShrink": "0",
    "overflow": "hidden",
    "@media (min-width: 1024px)": {
      "height": "4.8rem",
      "width": "7.2rem"
    }
  }, {
    "borderRadius": "4px",
    "borderWidth": "1px",
    "transitionProperty": "color, background-color, border-color, text-decoration-color, fill, stroke",
    "transitionDuration": "250ms",
    "transitionTimingFunction": "ease-in-out"
  }, {
    "@media (hover: hover)": {
      "&:hover": {
        "borderColor": "rgba(255, 255, 255, 0.5)"
      }
    }
  }, isActive ? {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(75 46 248 / var(--tw-border-opacity))"
  } : {
    "borderColor": "transparent"
  }]}>
      {image}
      <AnimatePresence>{isActive && <DeepDiveGalleryControlProgress />}</AnimatePresence>
    </_StyledButton>;
}
var _StyledButton = /*#__PURE__*/_styled("button").withConfig({
  displayName: "deep-dive-gallery-control___StyledButton",
  componentId: "sc-vo4kpv-0"
})(["", ""], p => p.$_css);